import React from "react";
import { Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faMagnifyingGlass, faDownload } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

const STAT_META = [
  { key: "total_visitors",  icon: faEye,             color: "#6366f1", bg: "#eef2ff", labelKey: "event_stats.visitors"  },
  { key: "total_matches",   icon: faMagnifyingGlass, color: "#ec4899", bg: "#fdf2f8", labelKey: "event_stats.matches"   },
  { key: "total_downloads", icon: faDownload,        color: "#10b981", bg: "#ecfdf5", labelKey: "event_stats.downloads" },
];

const EventStatsCard = ({ stats }) => {
  const { t } = useTranslation();
  if (!stats) return null;

  return (
    <Card
      className="mt-3"
      style={{ border: "none", borderRadius: "16px", boxShadow: "0 1px 3px rgba(0,0,0,0.08), 0 4px 16px rgba(0,0,0,0.06)", overflow: "hidden" }}
    >
      <Card.Body style={{ padding: "20px 24px" }}>
        <div style={{ fontSize: "11px", fontWeight: 700, color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: "14px" }}>
          {t("event_stats.title")}
        </div>
        <div style={{ display: "flex", gap: "10px" }}>
          {STAT_META.map(({ key, icon, color, bg, labelKey }) => (
            <div
              key={key}
              style={{ flex: 1, background: "#fafafa", border: "1px solid #f0f0f0", borderRadius: "12px", padding: "14px 16px" }}
            >
              <div style={{ width: 32, height: 32, borderRadius: "8px", background: bg, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "10px" }}>
                <FontAwesomeIcon icon={icon} style={{ color, fontSize: "14px" }} />
              </div>
              <div style={{ fontSize: "22px", fontWeight: 700, color: "#111827", lineHeight: 1 }}>
                {stats[key] ?? 0}
              </div>
              <div style={{ fontSize: "11px", color: "#9ca3af", marginTop: "5px", fontWeight: 500 }}>
                {t(labelKey)}
              </div>
            </div>
          ))}
        </div>
      </Card.Body>
    </Card>
  );
};

export default EventStatsCard;
